/**
 * Generated by orval v8.9.1 🍺
 * Do not edit manually.
 * Praetoid Dashboard API
 * OpenAPI spec version: 1.0
 */
import * as zod from 'zod';

export const SessionToken = zod
	.object({
		context: zod.string().describe('Session context'),
		insertedAt: zod.iso.datetime({ offset: true }).describe('Session creation time'),
		token: zod.string().describe('Base64 encoded token'),
		trackingId: zod.string().describe('Tracking ID for session')
	})
	.describe('A user session token');

export type SessionToken = zod.input<typeof SessionToken>;
export type SessionTokenOutput = zod.output<typeof SessionToken>;
